import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandCollapseAnimation = trigger('expandCollapse', [
    state(
        'collapsed',
        style({
            height: '*',
            overflow: 'hidden',
        }),
    ),
    state(
        'expanded',
        style({
            height: '*',
            overflow: 'hidden',
        }),
    ),
    transition(
        'collapsed <=> expanded',
        [style({ height: '{{startHeight}}px' }), animate('200ms ease-in-out', style({ height: '*' }))],
        { params: { startHeight: 0 } },
    ),
]);
